(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

window.addEventListener('load', function() {
  const header = document.querySelector('.header-wrapper--negative-margin');
  if (header) {
    const headerHeight = header.offsetHeight;
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    document.documentElement.classList.remove("no-header-height");
  }
});

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.addEventListener('resize', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        document.documentElement.classList.add("has-sticky-header")
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (scrollTop >= 0) this.classList.remove("header-wrapper--transparent")
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      } else {
        if (this.dataset.headerTransparent === "true") {
          this.classList.add("header-wrapper--transparent")
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["secret-gainant-finder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalize = (value) => String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();

    const colorKey = (value) => {
      const v = normalize(value);
      if (/noir|black/.test(v)) return 'black';
      if (/nude|beige|chair|skin|sable|camel/.test(v)) return 'nude';
      if (/blanc|white|ivoire|ivory|creme|cream/.test(v)) return 'white';
      if (/marron|brown|chocolat|coffee|cafe/.test(v)) return 'brown';
      return '';
    };

    const overrides = {
      'gaine-ventre-plat-efficace': { level: 3, support: true },
      'gaine-sculptante': { level: 3, support: true },
      'gaine-femme': { level: 3, support: true, full: true },
      'gaine-amincissante-femme': { level: 3, support: true },
      'gaine-amincissante': { level: 3, support: true },
      'gaine-pour-ventre-plat': { level: 3, support: true },
      'body-gainant-ventre-plat': { level: 3, support: true },
      'gaine-ventre-plat-invisible': { invisible: true, comfort: true },
      'gaine-amincissante-invisible': { invisible: true, comfort: true },
      'gaine-invisible-sous-robe': { invisible: true, dress: true, event: true },
      'body-gainant-ventre-plat-invisible': { invisible: true },
      'body-gainant-dos-nu': { backless: true, dress: true, event: true },
      'body-gainant-sans-bretelles': { backless: true, dress: true, event: true },
      'culotte-gainante-mariage': { invisible: true, dress: true, event: true },
      'culotte-gainante-post-partum': { postpartum: true, comfort: true },
      'culotte-gainante-taille-haute': { comfort: true },
      'body-gainant-dentelle': { event: true },
      'body-string-gainant': { dress: true, event: true }
    };

    const buildProfile = (product) => {
      const text = normalize([product.title, product.handle, (product.tags || []).join(' '), product.description].join(' '));
      const isSwim = /maillot/.test(text);
      const isBody = /body/.test(text);
      const isCulotte = /culotte/.test(text);
      const isGaine = /gaine/.test(text);
      const isCorset = /corset|bustier/.test(text);
      const isRobe = /robe/.test(text);
      let level = 2;
      if (/ultra|efficace|maintien ferme|gainage fort|sculptant|sculptante|amincissant|amincissante|minceur/.test(text)) level = 3;
      if (/leger|legere|douceur|doux|seconde peau/.test(text) && !/ferme|fort/.test(text)) level = 1;

      const profile = {
        full: isBody || isSwim || /integral/.test(text),
        waist: isBody || isGaine || isCulotte || isCorset || isSwim,
        upper: isBody || isCorset || /bustier|dos nu|sans bretelles/.test(text),
        lower: isCulotte || isGaine,
        level,
        daily: !isSwim && !isCorset && !isRobe,
        dress: /invisible|robe|string|dos nu|sans bretelles|mariage/.test(text) || isBody || isCulotte,
        event: /mariage|dentelle|corset|bustier|dos nu|sans bretelles|soiree/.test(text),
        postpartum: /post.?partum|apres grossesse/.test(text),
        swim: isSwim,
        invisible: /invisible|discret|seconde peau/.test(text),
        comfort: /confort|doux|douce|respirant|seconde peau/.test(text),
        support: level === 3 || /maintien ferme/.test(text),
        backless: /dos nu|sans bretelles/.test(text),
        colors: (product.colors || []).map(colorKey).filter(Boolean)
      };
      return Object.assign(profile, overrides[product.handle] || {});
    };

    document.querySelectorAll('[data-sg-finder]').forEach((root) => {
      if (root.dataset.sgReady === 'true') return;
      root.dataset.sgReady = 'true';

      const dataNode = root.querySelector('[data-sg-products]');
      let products = [];
      try { products = JSON.parse(dataNode.textContent || '[]'); } catch (e) { products = []; }

      const unique = new Map();
      products.forEach((product) => {
        if (product && product.handle && !unique.has(product.handle)) unique.set(product.handle, product);
      });
      products = Array.from(unique.values()).filter((product) => product.available).map((product) => ({ ...product, profile: buildProfile(product) }));

      const steps = Array.from(root.querySelectorAll('[data-sg-step]'));
      const stepKeys = steps.map((step) => step.dataset.sgStep);
      const answers = {};
      let current = 0;

      const progress = root.querySelector('[data-sg-progress]');
      const stepLabel = root.querySelector('[data-sg-step-label]');
      const progressLabel = root.querySelector('[data-sg-progress-label]');
      const back = root.querySelector('[data-sg-back]');
      const nav = root.querySelector('[data-sg-nav]');
      const results = root.querySelector('[data-sg-results]');
      const resultGrid = root.querySelector('[data-sg-result-grid]');
      const stepsWrap = root.querySelector('[data-sg-steps]');
      const progressWrap = root.querySelector('.sg-finder__progress-wrap');

      const renderStep = () => {
        steps.forEach((step, index) => { step.hidden = index !== current; });
        const pct = Math.round(((current + 1) / steps.length) * 100);
        progress.style.width = `${pct}%`;
        stepLabel.textContent = `Étape ${current + 1} sur ${steps.length}`;
        progressLabel.textContent = `${pct}%`;
        back.disabled = current === 0;

        const active = steps[current];
        active.querySelectorAll('[data-value]').forEach((button) => {
          button.classList.toggle('is-selected', answers[stepKeys[current]] === button.dataset.value);
        });
      };

      const zoneReason = {
        full: 'Pensé pour harmoniser l’ensemble de la silhouette',
        waist: 'Cible particulièrement le ventre et la taille',
        upper: 'Apporte du maintien sur le haut du corps',
        lower: 'Travaille en priorité le bas du corps'
      };
      const occasionReason = {
        daily: 'Adapté à un usage quotidien',
        dress: 'Pertinent sous une robe ou une tenue ajustée',
        event: 'Adapté à une occasion spéciale',
        postpartum: 'Correspond à votre recherche post-partum',
        swim: 'Conçu pour la plage et la piscine'
      };
      const priorityReason = {
        invisible: 'Finitions discrètes privilégiées',
        comfort: 'Le confort fait partie de ses points forts',
        support: 'Maintien renforcé pour un effet sculptant',
        backless: 'Coupe adaptée aux tenues dos nu ou sans bretelles',
        balanced: 'Bon équilibre entre maintien et polyvalence'
      };

      const scoreProduct = (product) => {
        const p = product.profile;
        let score = 0;
        let max = 0;

        max += 5;
        if (p[answers.zone]) score += 5;
        else if (answers.zone === 'full' && (p.waist && p.upper)) score += 3;
        else if (answers.zone !== 'full' && p.full) score += 3;

        max += 4;
        const wantedLevel = { comfort: 1, medium: 2, strong: 3 }[answers.level] || 2;
        const levelDelta = Math.abs((p.level || 2) - wantedLevel);
        if (levelDelta === 0) score += 4;
        else if (levelDelta === 1) score += 2;

        max += 5;
        if (p[answers.occasion]) score += 5;
        else if (answers.occasion === 'event' && p.dress) score += 3;
        else if (answers.occasion === 'dress' && p.event) score += 2;

        max += 3;
        if (answers.priority === 'balanced') score += 2;
        else if (p[answers.priority]) score += 3;

        max += 2;
        if (answers.color === 'any') score += 2;
        else if (p.colors.includes(answers.color)) score += 2;
        else if (!p.colors.length) score += 1;

        if (answers.occasion === 'swim' && !p.swim) score -= 8;
        if (answers.occasion !== 'swim' && p.swim) score -= 4;
        if (answers.occasion === 'postpartum' && !p.postpartum) score -= 5;
        if (answers.priority === 'backless' && !p.backless) score -= 4;

        return { product, score, max };
      };

      const escapeHtml = (value) => String(value || '').replace(/[&<>'"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[char]));

      const renderResults = () => {
        const ranked = products.map(scoreProduct).sort((a, b) => b.score - a.score).slice(0, 3);
        resultGrid.innerHTML = '';

        if (!ranked.length) {
          resultGrid.innerHTML = '<div class="sg-finder__empty"><strong>Aucun modèle disponible n’a pu être classé.</strong><br>Vous pouvez recommencer le diagnostic ou découvrir nos collections.</div>';
        } else {
          ranked.forEach((entry, index) => {
            const { product } = entry;
            const p = product.profile;
            const rawPct = Math.round((Math.max(0, entry.score) / entry.max) * 100);
            const pct = Math.min(98, Math.max(62, rawPct));
            const reasons = [];
            if (p[answers.zone] || (answers.zone !== 'full' && p.full)) reasons.push(zoneReason[answers.zone]);
            if (p[answers.occasion]) reasons.push(occasionReason[answers.occasion]);
            if (answers.priority === 'balanced' || p[answers.priority]) reasons.push(priorityReason[answers.priority]);
            if (answers.color !== 'any' && p.colors.includes(answers.color)) reasons.push('Disponible dans la couleur souhaitée');
            if (reasons.length < 2) reasons.push(p.level === 3 ? 'Gainage ferme et sculptant' : p.level === 1 ? 'Maintien plus doux et confortable' : 'Maintien sculptant équilibré');

            const card = document.createElement('article');
            card.className = `sg-finder__result${index === 0 ? ' sg-finder__result--best' : ''}`;
            card.innerHTML = `
              ${index === 0 ? '<span class="sg-finder__badge">MEILLEUR CHOIX</span>' : ''}
              <span class="sg-finder__match">${pct}% compatible</span>
              <a class="sg-finder__result-media" href="${escapeHtml(product.url)}" aria-label="Découvrir ${escapeHtml(product.title)}">
                ${product.image ? `<img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.imageAlt || product.title)}" loading="lazy" width="600" height="750">` : ''}
              </a>
              <div class="sg-finder__result-body">
                <h4 class="sg-finder__result-title">${escapeHtml(product.title)}</h4>
                <p class="sg-finder__result-price">${escapeHtml(product.price)}</p>
                <ul class="sg-finder__reasons">${reasons.slice(0, 3).map((reason) => `<li>${escapeHtml(reason)}</li>`).join('')}</ul>
                <a class="sg-finder__result-cta" href="${escapeHtml(product.url)}">Découvrir ce modèle</a>
              </div>`;
            resultGrid.appendChild(card);
          });
        }

        stepsWrap.hidden = true;
        nav.hidden = true;
        progressWrap.hidden = true;
        results.hidden = false;
        results.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };

      root.querySelectorAll('[data-sg-step] [data-value]').forEach((button) => {
        button.addEventListener('click', () => {
          answers[steps[current].dataset.sgStep] = button.dataset.value;
          button.closest('[data-sg-step]').querySelectorAll('[data-value]').forEach((choice) => choice.classList.toggle('is-selected', choice === button));
          window.setTimeout(() => {
            if (current < steps.length - 1) {
              current += 1;
              renderStep();
            } else {
              renderResults();
            }
          }, 120);
        });
      });

      back.addEventListener('click', () => {
        if (current > 0) {
          current -= 1;
          renderStep();
        }
      });

      root.querySelector('[data-sg-restart]').addEventListener('click', () => {
        Object.keys(answers).forEach((key) => delete answers[key]);
        current = 0;
        results.hidden = true;
        stepsWrap.hidden = false;
        nav.hidden = false;
        progressWrap.hidden = false;
        renderStep();
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      renderStep();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
